module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"david moinina sengeh","short_name":"dsengeh","start_url":"/","background_color":"#e7eef4","theme_color":"#e7eef4","icon":"src/images/favicon.png","display":"standalone","cache_busting_mode":"name","theme_color_in_head":false,"include_favicon":true,"legacy":true,"cacheDigest":"06a06cfc33cd0407627315a3a44b4be1"},
    },{
      plugin: require('../node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":2048},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
